import React from "react";
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>
          <a className="footer-brand" href="/">
            Quantingo
          </a>
          <p>Senior engineering for complex software and systems.</p>
        </div>
        <div className="footer-links">
          <a href="/quantingoapps">Application support</a>
          <a href="/engineering">Engineering</a>
          <a href="/contact">Contact</a>
          <span>© {new Date().getFullYear()} Quantingo</span>
        </div>
      </div>
    </footer>
  );
}
